// **** ageendar / agenda.jsx ****
// **** autor: Walcledson de Paula ****
// **** 14-06-24

// import { useState, useEffect, useContext } from 'react';
// import { useState, useContext } from 'react';
// import { AuthContext } from '../../../../../Context/auth.jsx';

import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';


import apiaxios from "../../../../../../Services/apiaxios.js";
import { decrypt } from '../../../../../../Services/cryptoUtils.js';
import Swal from 'sweetalert2';
import handleApiError from "../../../../../../Services/apiErrorHandler.js";
import { autoLogout } from '../../../../../../Services/authutils.js';

import Menu from "../../../../components/Menu/menu.jsx";
import Footer from "../../../../components/Footer/footer.jsx";
import CardCalendario from '../../../../components/Calendario/calendario.jsx';
import CardHorarios from '../../../../components/Calendario/horarios.jsx';

import './agendar.css';

function Agendar () {

    // const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    const tokenlg = localStorage.getItem("tokenlg");
    useEffect(() => {
        if (!tokenASW || !tokenlg) {
            console.error('token adulterado');
            autoLogout();
        }
    }, [tokenASW, tokenlg]);

    const [id_usuario, setId_usuario] = useState(() => {
        const encryptedUser = localStorage.getItem('tokenacw');
        if (encryptedUser) {
            try {
                const decryptedUser = decrypt(encryptedUser);
                return decryptedUser.id_usuario || 0;
            } catch (error) {
                console.error('Erro ao descriptografar ou fazer o parse dos dados:', error);
                return 0;
            }
        }
        return 0;
    });    
    // const user = localStorage.getItem("usuario");
    // const userObject = user ? JSON.parse(user) : null;
    // const id_usuario = userObject ? userObject.id_usuario : 0; // garantir que seja um valor no mínimo 0 / 16/6/24w

    // const id_usuario = userObject ? userObject.id_usuario : 10;  // Defina um valor padrão, se necessário
    // alert (id_usuario);
    // alert (localStorage.getItem("usuario"));

    // const { usuario } = useContext(AuthContext); // isso é uma porcaria 18/6/24w
    // // Exemplo de como acessar os dados
    // const id_usuario = usuario.id_usuario;

    const location = useLocation();
    const servicoData = location.state;
    const [horarios, setHorarios] = useState([]);
    const [vINTERVALOAGENDA, setVINTERVALOAGENDA] = useState(60); // Default value
    const [selectedHorario, setSelectedHorario] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null); // Definir o estado da data selecionada
    const navigate = useNavigate();

    // const history = useHistory();

    // alert(servicoData.tipo_agenda);

    // useEffect(() => {
    //     // Fetch intervalo_agenda
    //     apiaxios.get(`/configuracao/IntervaloAgenda`, { params: { id_empresa: servicoData.id_empresa } })
    //         .then(response => {
    //             console.log('Intervalo Agenda:', response.data);
    //             // alert('response data ' + response.data);
    //             if (response.data.retorno === 'OK') {
    //                 setVINTERVALOAGENDA(response.data.intervalo_agenda);
    //                 // alert('vintervalo agenda ' + vINTERVALOAGENDA);
    //                 console.log('vintervalo agenda ' + vINTERVALOAGENDA);
    //             } else {
    //                 // alert(`Erro: ${response.data.retorno}`);
    //                 console.log(`Erro: ${response.data.retorno}`);
    //             }
    //         })
    //         .catch(error => {
    //             console.error('Erro ao buscar intervalo_agenda:', error);
    //             setVINTERVALOAGENDA(60); // Default value in case of error
    //         });
    // // }, []);
    // // }, [servicoData.id_empresa]);
    // }, [servicoData.id_empresa, servicoData.id_servico, vINTERVALOAGENDA]); // Certifique-se de que essas dependências não estão mudando em um loop infinito

    const fetchHorarios = (date) => {
        if (!date) return; // Evita requisições desnecessárias se a data for nula

        const formattedDate = date.toISOString().split('T')[0];
        const endpoint = servicoData.tipo_agenda === 0 ? 
            `/servico/horarioGlobalDiario` :
            `/servico/horario`;

        const params = servicoData.tipo_agenda === 0 ? {
            id_usuario: servicoData.id_empresa,
            id_servico: servicoData.id_servico,
            dt: formattedDate,
            tempoAgendaMinutos: vINTERVALOAGENDA
        } : {
            id_servico: servicoData.id_servico,
            dt: formattedDate
        };

        // alert(params);
        // alert (endpoint);
        // console.log('Fetching horários from endpoint:', endpoint, 'with params:', params);
        // apiaxios.get(endpoint, { params })
        //     .then(response => {
        //         console.log('Horários:', response.data);
        //         const horariosDisponiveis = servicoData.tipo_agenda === 0 ? 
        //             response.data.map(item => item.HORA) : 
        //             response.data.map(item => item.SHO_HORA);
        //         setHorarios(horariosDisponiveis);
        //         console.log('após apiaxios ser acionada', response.data );
        //     })
        //     .catch(error => {
        //         console.error('Erro ao buscar horários:', error);
        //         setHorarios([]);
        //     });

        apiaxios.get(endpoint, { params })
            .then(response => {
                const horariosDisponiveis = response.data.map(item => ({
                    ...item,
                    selected: false,
                    label: item.label || item.HORA // Assegurar que existe uma propriedade para exibição
                }));
                setHorarios(horariosDisponiveis);
            })
            .catch(error => {
                // console.error('Erro ao buscar horários:', error);
                handleApiError(error);
                setHorarios([]);
            });
    };

    const handleSelectDate = (date) => {
        // alert('dia clicado ' + date);
        // console.log('Selected date:', date);
        fetchHorarios(date);
        setSelectedHorario(null); // limpa o horário selecionado e oculta o botão "Confirmar Agendamento"
    };

    // useEffect(() => {
    //     // Seleciona a data atual ao montar o componente
    //     fetchHorarios(new Date());
    // }, []); // Executa apenas uma vez ao montar o componente

    // const handleSelectDate = useCallback((date) => {
    //     console.log('Selected date:', date);
    //     fetchHorarios(date);
    // }, []);

    const formatCurrency = (value) => {
        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    const onSelectHorario = (horaSelecionada) => {
        const updatedHorarios = horarios.map(hora => ({
            ...hora,
            selected: hora.HORA === horaSelecionada.HORA
        }));
        setHorarios(updatedHorarios);
        setSelectedHorario(horaSelecionada);
    };

    // Função para formatar a data
    const formatarData = (data) => {
        const partes = data.split('/');
        return `${partes[2]}/${partes[1]}/${partes[0]}`;
    };

    const onConfirmaAgendamento = () => {

        // if (!selectedDate || !selectedHorario) {
        // console.log('selectdate ', selectedDate, 'selecthorario', selectedHorario);
        // console.log('selecthorario', selectedHorario);

        if (!selectedHorario) {
            Swal.fire('Erro', 'Você precisa marcar um dia e horário para confirmar agendamento', 'error');
            return;
        }

        Swal.fire({
            title: 'Confirmação!',
            text: `Você confirma este agendamento no Agendex Cliente Web?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, agendar!',
            cancelButtonText: 'Cancelar'
          }).then((result) => {
            if (result.isConfirmed) {

                const checkAgendaFechada = async () => {
                    try {
                        const response = await apiaxios.get('/Empresa/AgendaFechada', {
                            params: { id_usuario: servicoData.id_empresa }
                        });
        
                        if (response.status === 200) {
                            const data = response.data;
                            if (data.retorno !== 'OK') {
                                Swal.fire('Erro', data.retorno, 'error');
                                return false;
                            }
        
                            // const agendaFechada = data.agenda_fechada || 0;
                            const agendaFechada = data.agenda_fechada === null ? 0 : data.agenda_fechada;

                            if (agendaFechada === 1) {
                                Swal.fire('Empresa com Agenda fechada temporariamente!', '', 'info');
                                return false;
                            }
        
                            return true;
                        } else {
                            Swal.fire('Erro', 'Falha ao verificar a agenda. Tente novamente mais tarde.', 'error');
                            return false;
                        }
                    } catch (error) {
                        Swal.fire('Erro', 'Erro ao verificar a agenda: ' + error.message, 'error');
                        return false;
                    }
                };
        
                const agendarServico = async () => {
                    // console.log('data do agendamento ', selectedDate.toISOString().split('T')[0]);
                    const dataFormatada = formatarData(selectedHorario.DATA);
                    const isAgendaAberta = await checkAgendaFechada();
                    if (!isAgendaAberta) 
                        return;
                    // console.log('dentro do agendarServiço', id_usuario, servicoData.id_servico, servicoData.id_empresa, selectedHorario.label);
                    // console.log('selecthorario.data', selectedHorario.DATA);
                    try {
                        // Ajuste a data antes de enviar ao servidor
                        // const adjustedDate = new Date(selectedDate);
                        // adjustedDate.setDate(adjustedDate.getDate() - 1); // Subtrai um dia
                        alert('servico/agendar');
                        console.log('servico/agendar');
                        const response = await apiaxios.post('/servico/agendar', {
                            id_usuario: id_usuario, // Supondo que `id_usuario` esteja disponível em `servicoData`
                            id_servico: servicoData.id_servico,
                            id_empresa: servicoData.id_empresa,
                            
                            // dt: selectedDate.toISOString().split('T')[0],
                            // dt: selectedHorario.DATA, // Usando a data diretamente de selectedHorario
                            // dt: adjustedDate.toISOString().split('T')[0], // Usa a data ajustada
                            
                            dt: dataFormatada, // Usando a data formatada
                            hora: selectedHorario.label,
                            id_status: 1
                        });
        
                        if (response.status === 201) {
                            const data = response.data;
                            if (data.retorno === 'OK') {
                                // Swal.fire('Sucesso', `Agendamento nº ${data.id_reserva} realizado com sucesso!`, 'success');
                                Swal.fire('Sucesso', `Agendamento nº ${data.id_reserva} realizado com sucesso!`, 'success').then(() => {
                                    // history.push('/app/cliente/home');
                                    navigate('/app/cliente/home');

                                });
                            } else {
                                Swal.fire('Erro', data.retorno, 'error');
                            }
                        } else {
                            Swal.fire('Erro', 'Falha ao confirmar agendamento. Tente novamente mais tarde.', 'error');
                        }
                    } catch (error) {
                        Swal.fire('Erro', 'Erro ao confirmar agendamento: ' + error.message, 'error');
                    }
                };
                agendarServico();
            }
          });
    };


    return (
        <>
            <div className="container-fluid">
                <div className="row flex-nowrap">
                    <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                        <Menu page="agenda"/>
                    </div>
                    {/* <div className="col py-3 me-3"> */}
                    <div className="col py-3 me-3 main-content">
                        <div className="text-center">
                            <h1>Fazer um agendamento</h1>
                        </div>
                        <hr />
                        {/* <div className="col-lg-12 col-md-4 col-sm-12"> */}
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className='box-detalhe-agenda'>
                                <CardCalendario onSelectDate={handleSelectDate} />
                                {/* <h5>{servicoData.fone_empresa}</h5> */}
                                <hr />
                            </div>
                        </div> 

                        {/* <h2>Selecione o horário</h2>
                        {horarios.length === 0 ? (
                            <p className="text-danger">Nenhum horário disponível para este dia</p>
                        ) : (
                            horarios.map((hora, index) => (
                                <p key={index}>{hora}</p>
                            ))
                        )} */}
                         <CardHorarios horarios={horarios} onSelectHorario={onSelectHorario}/>
                        <hr />
                        <h2>{servicoData.nome_servico}</h2>
                        <p className={servicoData.vr_servico === 0 ? 'highlight-red' : ''}>
                            {servicoData.vr_servico === 0 ? 'VALOR A COMBINAR' : formatCurrency(servicoData.vr_servico)}
                        </p>

                        {/* <p>{servicoData.vr_servico}</p> */}
                        <hr />
                        <div className="text-center">
                            <button 
                                type="button" 
                                className="btn btn-success"
                                disabled={!selectedHorario} // Botão desativado enquanto não há horário selecionado
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title='O dia/horário acima foi selecionado. Clique para confirmar seu agendamento!'
                                onClick={() => onConfirmaAgendamento()}
                            >
                                Confirmar Agendamento
                                
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    );
}

export default Agendar;

// function Agendar() {
//     const location = useLocation();
//     const servicoData = location.state;
//     const [intervaloAgenda, setIntervaloAgenda] = useState(60);  // Default to 60 if not fetched
//     const [horarios, setHorarios] = useState([]);
//     const [selectedDate, setSelectedDate] = useState(new Date());
//     const [selectedHorario, setSelectedHorario] = useState(null);

//     useEffect(() => {
//         const fetchIntervaloAgenda = async () => {
//             try {
//                 const response = await apiaxios.get(`/configuracao/IntervaloAgenda?id_empresa=${servicoData.id_empresa}`);
//                 if (response.data.retorno === 'OK') {
//                     setIntervaloAgenda(response.data.intervalo_agenda);
//                     localStorage.setItem('vINTERVALOAGENDA', response.data.intervalo_agenda);
//                 } else {
//                     // Handle error case
//                     console.error('Erro ao buscar intervalo da agenda');
//                 }
//             } catch (error) {
//                 console.error('Erro ao buscar intervalo da agenda', error);
//                 localStorage.setItem('vINTERVALOAGENDA', 60);
//             }
//         };

//         fetchIntervaloAgenda();
//     }, [servicoData.id_empresa]);

//     useEffect(() => {
//         const fetchHorarios = async () => {
//             const tipoAgenda = servicoData.tipo_agenda;
//             const url = tipoAgenda === 0
//                 ? `/servico/horarioGlobalDiario?id_usuario=${servicoData.id_empresa}&id_servico=${servicoData.id_servico}&dt=${selectedDate.toISOString().split('T')[0]}&tempoAgendaMinutos=${intervaloAgenda}`
//                 : `/servico/horario?id_servico=${servicoData.id_servico}&dt=${selectedDate.toISOString().split('T')[0]}`;

//             try {
//                 const response = await apiaxios.get(url);
//                 setHorarios(response.data);
//             } catch (error) {
//                 console.error('Erro ao buscar horários', error);
//             }
//         };

//         fetchHorarios();
//     }, [selectedDate, intervaloAgenda, servicoData]);

//     const handleDateSelect = (date) => {
//         setSelectedDate(date);
//         setSelectedHorario(null);  // Reset selected time when date changes
//     };

//     const handleHorarioSelect = (horario) => {
//         setSelectedHorario(horario);
//     };

//     const handleAgendamento = async () => {
//         const agendamentoData = {
//             id_usuario: localStorage.getItem('id_usuario'),
//             id_servico: servicoData.id_servico,
//             id_empresa: servicoData.id_empresa,
//             dt: selectedDate.toISOString().split('T')[0],
//             hora: selectedHorario,
//             id_status: 1
//         };

//         try {
//             await apiaxios.post('/servico/agendar', agendamentoData);
//             alert('Agendamento realizado com sucesso!');
//         } catch (error) {
//             console.error('Erro ao realizar agendamento', error);
//             alert('Erro ao realizar agendamento');
//         }
//     };

//     return (
//         <div className="container-fluid">
//             <div className="row flex-nowrap">
//                 <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
//                     <Menu page="agenda"/>
//                 </div>
//                 <div className="col py-3 me-3">
//                     <div className="text-center">
//                         <h1>Fazer um agendamento</h1>
//                     </div>
//                     <hr />
//                     <div className="col-lg-12 col-md-4 col-sm-12">
//                         <div className='box-detalhe-agenda'>
//                             <div className='row '>
//                                 <CardCalendario onSelectDate={handleDateSelect}/>
//                             </div>
//                         </div>
//                     </div>

//                     <h4>Selecione o horário</h4>
//                     <div className="horarios">
//                         {horarios.map((horario, index) => (
//                             <button
//                                 key={index}
//                                 className={`btn ${selectedHorario === horario ? 'btn-primary' : 'btn-light'}`}
//                                 onClick={() => handleHorarioSelect(horario.HORA)}
//                             >
//                                 {horario.HORA}
//                             </button>
//                         ))}
//                     </div>
//                     <hr />
//                     <h2>{servicoData.nome_servico}</h2>
//                     <p>{servicoData.vr_servico}</p>
//                     <hr />
//                     <div className="text-center">
//                         {selectedHorario && (
//                             <button 
//                                 type="button" 
//                                 className="btn btn-success"
//                                 onClick={handleAgendamento}
//                             >
//                                 Confirmar Agendamento
//                             </button>
//                         )}
//                     </div>
//                 </div>
//             </div>
//             <Footer/>
//         </div>
//     );
// }

// export default Agendar;





// // import { useLocation } from 'react-router-dom';

// // import Menu     from "../../../../components/Menu/menu.jsx";
// // import Footer from "../../../../components/Footer/footer.jsx";
// // // import apiaxios from "../../../../services/apiaxios.js";

// // import './agendar.css';




// // function Agendar () {
// //     const location = useLocation();
// //     const servicoData = location.state;
// //     // alert (servicoData.id_servico);

// //     return <>
// //         <div className="container-fluid">
// //             <div className="row flex-nowrap">
// //                 <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
// //                     <Menu page="agenda"/>
// //                 </div>
// //                 <div className="col py-3 me-3">
// //                     <div className="text-center">
// //                         <h1>Fazer um agendamento</h1></div>
// //                         <hr />
// //                         <div className="col-lg-12 col-md-4 col-sm-12">
// //                             <div className='box-detalhe-agenda'>
// //                                 <div className='row '>
// //                                     <div className="col d-flex justify-content-home">
// //                                         <button
// //                                             className="btn btn-link"
// //                                             // onClick={mesAnterior}
// //                                             >
// //                                             <i className="fs-1 bi bi-chevron-left"></i>
// //                                         </button>
// //                                     </div>                                    
// //                                     <h3 className="col py-3">
// //                                         Junho / 2024
// //                                     </h3>

// //                                     <div className="col d-flex justify-content-end">
// //                                         <button
// //                                             className="btn btn-link"
// //                                             // onClick={mesProxdimo}
// //                                             >
// //                                             <i className="fs-1 bi bi-chevron-right"></i>
// //                                         </button>
// //                                     </div>                                    
// //                                     <h5>
// //                                         {servicoData.fone_empresa}
// //                                     </h5>
// //                                     <hr />
// //                                 </div>
// //                             </div>
// //                         </div> 
// //                     <h5>D   S  T  Q  Q  S   S</h5>
// //                     <p>Semana 1</p>
// //                     <p>Semana 2</p>
// //                     <p>Semana 3</p>
// //                     <p>Semana 4</p>
// //                     <p>Semana 5 - se houver</p>
// //                     <p>Semana 6 - se houver</p>
// //                     <hr />
// //                     <h2>Selecione o horário</h2>
// //                     <p>15:30   16:00   16:30   17</p>
// //                     <p>scroll horizontal para ver mais horários</p>
// //                     <hr />
// //                     {/* <h2>{(servicoData.id_servico)}</h2> */}
// //                     <h2>{(servicoData.nome_servico)}</h2>
// //                     <p>{(servicoData.vr_servico)}</p>
// //                     <hr />
// //                     <div className="text-center">
// //                         <button type="button" className="btn btn-success">Confirmar Agendamento</button>
// //                     </div>
// //                 </div>
// //             </div>
// //         </div>
// //         <Footer/>
// //     </>
// // }
// // export default Agendar;